import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@onefootprint/ui';
type LogoProps = {
  orgName: string;
  logoUrl?: string;
};
const Logo = t0 => {
  const $ = _c(3);
  const {
    orgName,
    logoUrl
  } = t0;
  let t1;
  if ($[0] !== logoUrl || $[1] !== orgName) {
    t1 = <div className="flex content-center justify-center"><div className="w-fit border border-solid border-tertiary rounded-full"><Avatar name={orgName} size="xlarge" src={logoUrl} /></div></div>;
    $[0] = logoUrl;
    $[1] = orgName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Logo;